import { combineReducers } from '@reduxjs/toolkit';

import app from './app';
import debug from './debug';
import moveInFeedback from './moveInFeedback';
import autocompleteAddress from './autocompleteAddress';

const rootReducer = (routerReducer) => {
  return combineReducers({
    router: routerReducer,
    app,
    debug,
    moveInFeedback,
    autocompleteAddress,
  });
};

export default rootReducer;
